import { FC, ReactNode, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/atoms/LabeledElement/LabeledElement.styl'
import Flex, { FlexGap } from 'components/atoms/Flex/Flex'
import TooltipIcon from 'components/atoms/TooltipIcon/TooltipIcon'

type KeyValueTheme = 'bold' | 'regular' | 'hero' | 'rewards'

type LabeledElement = {
  label: string
  element: string | ReactNode
  hint?: string | ReactNode
  underline?: ReactNode
  theme?: KeyValueTheme
  action?: () => void
  vertical?: boolean
  verticallyCenter?: boolean
  align?: 'left' | 'right' | 'center'
  gap?: FlexGap
}

export const LabeledElement: FC<LabeledElement> = (props) => {
  const { label, element, action, hint, align = 'center', theme = 'regular', underline, vertical, verticallyCenter, gap = 'micro' } = props

  const actionChild = useMemo(() => !!action && (
    <button onClick={ action }>{ '>' }</button>
  ), [action])

  const hintIconChild = useMemo(() => !!hint && (
    <TooltipIcon content={ hint } />
  ), [hint])

  const labelChild = useMemo(() => !!hintIconChild ? (
    <Flex horizontal gap='none'>{ label }{ hintIconChild }</Flex>
  ) : (
    label
  ), [hintIconChild, label])

  const classNames = cn(
    styles.item, {
      [styles.alignLeft]: align === 'left',
      [styles.alignRight]: align === 'right',
    }
  )

  return (
    <Flex
      className={ classNames }
      horizontal={ !vertical }
      gap={ vertical ? gap : 'spread' }
      horizontallyCenter={ vertical && align === 'center' }
      verticallyCenter={ verticallyCenter }
    >
      <div className={ styles.label }>
        { labelChild }
        { underline }
      </div>
      <div className={ cn(styles.element, styles[theme]) }>
        { element }
        { actionChild }
      </div>
    </Flex>
  )
}

export const LabeledElementList: FC<{}> = ({ children }) => {
  return (
    <ul className={ cn(styles.labeledElementList) }>
      { children }
    </ul>
  )
}
